var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _vm.checkForMotif && !_vm.hasMotif
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "320" },
              model: {
                value: _vm.dialogCloseChat,
                callback: function($$v) {
                  _vm.dialogCloseChat = $$v
                },
                expression: "dialogCloseChat"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "primary white--text subheading" },
                    [_vm._v(_vm._s(_vm.$t("closeChatTitle")))]
                  ),
                  _vm._v(" "),
                  _c("v-card-text", [_vm._v(_vm._s(_vm.$t("tagBeforeClose")))]),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "blue--text darken-1",
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.fermeDialog()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("cancel")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "500" },
              model: {
                value: _vm.dialogCloseChat,
                callback: function($$v) {
                  _vm.dialogCloseChat = $$v
                },
                expression: "dialogCloseChat"
              }
            },
            [
              _vm.$route.fullPath === "/trafic/attente" || _vm.directChat
                ? _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text subheading" },
                        [_vm._v(_vm._s(_vm.$t("Fermeture de la conversation")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("p", [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm.$t(
                                    "Votre message a bien été envoyé au visiteur, tous les messages de ce visiteurs ont été supprimés de la liste des messages en attente"
                                  )
                                ) +
                                "\n        "
                            )
                          ]),
                          _vm._v(
                            "\n        Cette conversation se fermera automatiquement dans "
                          ),
                          _c("wz-timer", { attrs: { timeLeft: _vm.timeLeft } }),
                          _vm._v(" s\n\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.fermeDialog()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.fermeChat()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("close")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-card",
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "primary white--text subheading" },
                        [_vm._v(_vm._s(_vm.$t("closeChatTitle")))]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(_vm._s(_vm.$t("beforeCloseOptions")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("v-switch", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.checkKetB,
                                expression: "checkKetB"
                              }
                            ],
                            attrs: {
                              disabled: _vm.checkSatisfaction,
                              label: _vm.$t("sendSatisfactionSurvey"),
                              "hide-details": ""
                            },
                            model: {
                              value: _vm.formulaireSatisfaction,
                              callback: function($$v) {
                                _vm.formulaireSatisfaction = $$v
                              },
                              expression: "formulaireSatisfaction"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c("v-switch", {
                            attrs: {
                              label: _vm.$t("closeThisChat"),
                              hint: _vm.$t("closeThisChatHint"),
                              "persistent-hint": ""
                            },
                            model: {
                              value: _vm.clotureChat,
                              callback: function($$v) {
                                _vm.clotureChat = $$v
                              },
                              expression: "clotureChat"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.fermeDialog()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("cancel")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "blue--text darken-1",
                              attrs: { flat: "" },
                              on: {
                                click: function($event) {
                                  return _vm.fermeChat()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("close")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63765902", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63765902","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogCloseChat.vue
// module id = null
// module chunks = 